import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { notyError } from '@shared/lib/notifications'
import {
  getSessionStorageValue,
  setSessionStorageValue,
} from '@shared/lib/storage'
import { useTgData } from '@shared/lib/useTgData'
import { changeAuthStatus, setAuth, setAuthError } from '@shared/store'

import { getLoginInfo } from './api'

//
//

let loginInfoRequest = null

//
//

const requestLoginInfo = () => {
  if (!loginInfoRequest) {
    loginInfoRequest = getLoginInfo().finally(() => {
      loginInfoRequest = null
    })
  }

  return loginInfoRequest
}

//
//

export const useTgAuth = () => {
  const dispatch = useDispatch()

  const authData = useSelector((state) => state.auth)

  const { i18n } = useTranslation()

  //
  //

  const tgData = useTgData()

  //
  //

  // Save initData to sessionStorage
  useEffect(() => {
    if (!tgData.isReady) {
      return
    }

    if (!getSessionStorageValue('initData', false)) {
      setSessionStorageValue('initData', tgData.initData, false)
    }
  }, [tgData])

  useEffect(() => {
    if (!authData.status) {
      return
    }

    const lang =
      authData.data.user.tgLanguageCode === 'en'
        ? 'enUS'
        : authData.data.user.tgLanguageCode

    i18n.changeLanguage(lang)

    setSessionStorageValue('language', lang, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authData.status])

  // Check auth status
  useEffect(() => {
    // if tgData not ready or status is null (checking) or already authorized
    if (
      !tgData.isReady ||
      authData.status === null ||
      authData.status === true ||
      authData.errorStatus === 401
    ) {
      return
    }

    dispatch(changeAuthStatus(null))

    //
    //

    const fn = async () => {
      const apiRes = await requestLoginInfo()

      if (apiRes?.status === 401) {
        dispatch(setAuthError(apiRes.status))

        return
      }

      if (apiRes?.error) {
        notyError('Failed to authenticate. Please try again.')

        dispatch(changeAuthStatus(null))

        // ? add timer for retry?

        return
      }

      dispatch(setAuth({ status: true, data: apiRes.data }))
    }

    fn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tgData, authData.status])

  //
  //

  return authData
}
